import { Grid } from '@material-ui/core';
import React from 'react';
import HelperPage from 'v2/components/Shared/HelperPage';

import ListNotification from './ListNotification';
import useStyle from './styles';

const Notifications = () => {
  const classes = useStyle();
  return (
    <>
      <Grid id='my-notifications' container spacing={2} justify='space-between' alignItems='flex-start'>
        <div className={classes.title}>
          <h1>Notificações</h1>
          <p>Mantenha-se atualizado de todos os status da sua aplicação.</p>
        </div>
        <HelperPage id='list_notification_button' title='Notificações' name='list_notifications' />
      </Grid>
      <div className='m32' />
      <Grid className={classes.root} container>
        <Grid item xs={12}>
          <ListNotification />
        </Grid>
      </Grid>
    </>
  );
};

export default Notifications;
